import { REQUEST_CHECKLIST, RECEIVE_CHECKLIST, REQUEST_STATS, RECEIVE_STATS, RESET_CHECKLIST } from '../../actions/types/ChecklistActionTypes';

const initialState = {
  busy: false,
  initialized: false,
  id: null,
  isDetailed: false,
  templateIds: [],
  globalStats: [],
  checklistUsers: []
};

const checklistReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_CHECKLIST: {
      return { ...state, busy: true };
    }
    case RECEIVE_CHECKLIST: {
      const checklist = action.payload.checklist;

      return Object.assign(
        {},
        state,
        { id: checklist.id },
        { isDetailed: checklist.is_detailed },
        { templateIds: checklist.template_ids },
        { globalStats: checklist.global_stats },
        { checklistUsers: checklist.checklist_users },
        { busy: false, initialized: true },
      );
    }
    case REQUEST_STATS: {
      return state;
    }
    case RECEIVE_STATS: {
      return Object.assign(
        {},
        state,
        { globalStats: action.payload.globalStats }
      );
    }
    case RESET_CHECKLIST: {
      return initialState;
    }
    default: return state;
  }
};

export default checklistReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/checklist/checklist.js
 **/